export const getIsBotNotificationsFetching = (state) =>
  state.botNotifications.main.isFetching;

export const getBotNotificationsError = (state) =>
  state.botNotifications.main.error;

export const getIsBotNotificationsOk = (state) =>
  state.botNotifications.main.data &&
  state.botNotifications.main.data.status &&
  state.botNotifications.main.data.status === 'success'
    ? false
    : false;

export const getBotNotificationsData = (state) =>
  state.botNotifications.main.data?.data || {};
